import cn from 'classnames';
import dayjs from 'dayjs';
import customeParse from 'dayjs/plugin/customParseFormat';
import { FC } from 'react';
import { BsCalendarDate } from 'react-icons/bs';
import { Container } from '../../../components/container/container';
import { MaskedInput } from '../../../components/input/masked-input';
import { Tooltip } from '../../tooltip/tooltip';
import { DatePickerCalendar } from './date-picker-calendar/date-picker-calendar';
import s from './date-picker.module.css';
import { DatePickerProps, useDatePicker } from './use-date-picker';

dayjs.extend(customeParse);

export const DatePicker: FC<DatePickerProps> = (props) => {
  const { selectedDate, placeholder, className, minDate, maxDate, name, label, required } = props;
  const {
    handleInputChange,
    handleSelectDate,
    inputValue,
    handleResetDate,
    handleClose,
    open,
    setOpen,
  } = useDatePicker(props);

  return (
    <div className={cn(s.component, className)}>
      {label ? (
        <Container label={label} required={required}>
          <MaskedInput
            value={inputValue}
            onChange={handleInputChange}
            placeholder={placeholder}
            name={name || 'date'}
            mask="__.__.____"
          />
        </Container>
      ) : (
        <MaskedInput
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          name={name || 'date'}
          mask="__.__.____"
        />
      )}

      <Tooltip
        triggerWrapperClassName={s.calendar}
        optionsWrapperClassName={s.calendarContent}
        trigger={<BsCalendarDate />}
        open={open}
        onOpen={setOpen}
      >
        <DatePickerCalendar
          handleSelectDate={handleSelectDate}
          maxDate={maxDate}
          minDate={minDate}
          selectedDate={selectedDate}
          handleClose={handleClose}
          handleReset={handleResetDate}
        />
      </Tooltip>
    </div>
  );
};
